/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Pause_CtaInputs */

const en_cancel_pause_cta = /** @type {(inputs: Cancel_Pause_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause for 1 month`)
};

const de_cancel_pause_cta = /** @type {(inputs: Cancel_Pause_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuer 1 Monat pausieren`)
};

const fr_cancel_pause_cta = /** @type {(inputs: Cancel_Pause_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause pendant 1 mois`)
};

const es_cancel_pause_cta = /** @type {(inputs: Cancel_Pause_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausar por 1 mes`)
};

const it_cancel_pause_cta = /** @type {(inputs: Cancel_Pause_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausa per 1 mese`)
};

const nl_cancel_pause_cta = /** @type {(inputs: Cancel_Pause_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pauzeer voor 1 maand`)
};

const pl_cancel_pause_cta = /** @type {(inputs: Cancel_Pause_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wstrzymaj na 1 miesiac`)
};

const fi_cancel_pause_cta = /** @type {(inputs: Cancel_Pause_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tauko 1 kuukaudeksi`)
};

const da_cancel_pause_cta = /** @type {(inputs: Cancel_Pause_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause i 1 måned`)
};

const sv_cancel_pause_cta = /** @type {(inputs: Cancel_Pause_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausa i 1 månad`)
};

/**
* | output |
* | --- |
* | "Pause for 1 month" |
*
* @param {Cancel_Pause_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_pause_cta = /** @type {((inputs?: Cancel_Pause_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Pause_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_pause_cta(inputs)
	if (locale === "fr") return fr_cancel_pause_cta(inputs)
	if (locale === "es") return es_cancel_pause_cta(inputs)
	if (locale === "it") return it_cancel_pause_cta(inputs)
	if (locale === "nl") return nl_cancel_pause_cta(inputs)
	if (locale === "pl") return pl_cancel_pause_cta(inputs)
	if (locale === "fi") return fi_cancel_pause_cta(inputs)
	if (locale === "da") return da_cancel_pause_cta(inputs)
	if (locale === "sv") return sv_cancel_pause_cta(inputs)
	return en_cancel_pause_cta(inputs)
});